import { takeLatest, put, select, all } from 'redux-saga/effects';

// Types:
import type {
  NearestDeparturesResponse,
  RecommendedCountriesResponse,
} from '@lt/api/dist/methods/searchBlocks/types';

// Api:
import { api } from 'src/api';

// Utils:
import { resetCityInUrl } from 'src/utils/uriUtils';

// Selectors:
import {
  getSearchParamsToCity,
  isSearchParamsRegionSelector,
} from 'src/store/enqueue/selectors';
import { getRequestId } from '../../selectors/searchParams';

// Actions:
import { changeSearchParamsAction } from '../../actions/search';
import {
  setIsEmptySearch,
  setEmptyRegion,
  setNearestDepartures,
  setRecommendedCountries,
} from './slices';

/**
 * Пустые поиски, вылет из ближайших городов
 */
function* getNearestDepartures() {
  const requestId = yield select(getRequestId);

  try {
    const { other_departures }: NearestDeparturesResponse =
      yield api.getSearchBlocksNearestDepartures({
        request_id: requestId,
      });

    if (other_departures) {
      yield put(setNearestDepartures(other_departures));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

/**
 * Пустые поиски, вылет в рекомендуемые страны
 */
function* getRecommendedCountries() {
  const requestId = yield select(getRequestId);

  try {
    const { other_countries }: RecommendedCountriesResponse =
      yield api.getSearchBlocksRecommendedCountries({
        request_id: requestId,
      });

    if (other_countries) {
      yield put(setRecommendedCountries(other_countries));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

/**
 * Пустые поиски, если поиск в регион и ничего не найдено, показываем результаты по всей стране
 */
function* getAllRegionsInCountry() {
  const isRegionSearch = yield select(isSearchParamsRegionSelector);
  const cityObj = yield select(getSearchParamsToCity);
  const { name_ru, name_en } = cityObj;

  if (isRegionSearch) {
    const newUrl = resetCityInUrl(name_en);

    yield put(changeSearchParamsAction(newUrl));
    yield put(
      setEmptyRegion({
        emptyRegionNameRu: name_ru,
        isEmptySearch: true,
      }),
    );
  }
}

function* handleEmptySearch() {
  yield getAllRegionsInCountry();
  yield getNearestDepartures();
  yield getRecommendedCountries();
}

export default function* emptySearchSaga() {
  yield all([takeLatest(setIsEmptySearch.type, handleEmptySearch)]);
}
